if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) {
        console.error('Form not found within product-form');
        return;
      }

      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.isCardProduct = this.closest('.product-card-wrapper') !== null;
    }

    async isCartEmpty() {
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      return cartData.item_count === 0;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const formData = this.prepareFormData();
      const config = this.prepareConfig(formData);

      let results = {};
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((result) => {
          results.response = result;
          return CartJS.getCart();
        })
        .then((cartJsResponse) => {
          return CartJS.getCart();
        })
        .then((cartJsResponse) => {
          this.handleResponse(results.response);
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('An error occurred. Please try again.');
        })
        .finally(() => {
          this.resetSubmitState();
          if (this.isCardProduct) {
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        });
    }

    prepareFormData() {
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section || section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      return formData;
    }

    prepareConfig(formData) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      return config;
    }

    handleResponse(response) {
      if (response.status) {
        this.handleErrorMessage(response.description);
        this.displaySoldOutMessage();
        this.error = true;
      } else {
        this.error = false;
        this.updateCartDisplay(response);
      }
    }

    updateCartDisplay(response) {
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          if (this.cart && document.body.classList.contains(AB_TEST_CLASSES.cartDrawer))
            this.cart.renderContents(response);
          else window.location.href = '/cart';
        }, { once: true });
        quickAddModal.hide(true);
      } else {
        if (this.cart && document.body.classList.contains(AB_TEST_CLASSES.cartDrawer))
          this.cart.renderContents(response);
        else window.location.href = '/cart';
      }
    }

    resetSubmitState() {
      this.submitButton.classList.remove('loading');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    displaySoldOutMessage() {
      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      if (!soldOutMessage) return;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.querySelector('span').classList.add('hidden');
      soldOutMessage.classList.remove('hidden');
    }
  });
}
